export default {
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(),
	partList: [],
	isDisabled: 'N' //협력사용 검색 방지
};

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 0
	};
}

function SEARCH_PARAMS() {
	return {
		partNo: '',
		partName: '',
		cpnyNm: '',
		cpnyCd: ''
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
